import { ReactNode, useEffect, useRef, useState } from 'react';
import Text12 from '@sdk/components/ui/typography/Text12';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  AnimatedPopupContainer,
  AnimatedPopupWrapper,
  Popup,
} from '@web/components/AnimatedPopup/animatedPopup.styles';

type Props = {
  onClick: () => void;
  children: ReactNode;
  label: string;
};

export const AnimatedPopup = ({ onClick, children, label }: Props) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const scheduledAnimationRef = useRef(false);

  const animatePopup = () => {
    setIsAnimating((v) => {
      // restart animation when clicked during animating
      scheduledAnimationRef.current = v;
      return !v;
    });
  };

  useEffect(() => {
    if (!isAnimating && scheduledAnimationRef.current) {
      scheduledAnimationRef.current = false;
      setIsAnimating(true);
    }
  }, [isAnimating]);

  const onPopupClick = () => {
    animatePopup();
    onClick?.();
  };

  return (
    <AnimatedPopupWrapper onClick={onPopupClick}>
      {children}
      <AnimatedPopupContainer>
        <Popup isAnimating={isAnimating} onAnimationEnd={() => setIsAnimating(false)}>
          <Text12 themeColor={ThemeColorType.white} bold>
            {label}
          </Text12>
        </Popup>
      </AnimatedPopupContainer>
    </AnimatedPopupWrapper>
  );
};
